(function (window) {
  function BatchGeoGroupDistance() {
    this.map = null;
    this.markers = [];
    this.distances = [];
    this.prev_locations = [];
    this.curr_locations = [];
    this.rowGroupA = [];
    this.rowGroupB = [];
    this.selectedIds = [];
    this.selectedIdPairs = [];
    this.polylineData = [];
    this.distanceMatrix = [];
    this.backupDistances = [];
    this.rowData = [];
    this.rowDataByStartId = {};

    this.columnCount = 0;
  }

  BatchGeoGroupDistance.prototype.initialize = function () {
    var map = window.batchGeoGoogleMapsManager.getMap();
    if (!map) return;

    this.setupListeners();

    this.map = map;
    this.markers = window.batchGeoGoogleMapsMarker.getMarkersObjArray() || [];

    const optimalRouteToolbar =
      BatchGeoStore.getState().BatchGeoOptimalRouteToolbar;

    this.rowGroupA = optimalRouteToolbar.selectedRowGroupA || [];
    this.rowGroupB = optimalRouteToolbar.selectedRowGroupB || [];

    if (optimalRouteToolbar.distanceChannel == 0)
      this.rowGroupB = this.rowGroupA;

    if (!this.rowGroupA || !this.rowGroupB) return;

    if (optimalRouteToolbar.distanceChannel !== 0)
      this.rowGroupB = this.rowGroupB.filter(
        (row) => !this.rowGroupA.includes(row),
      );

    if (this.rowGroupA) this.prev_locations = this.getLocations(this.rowGroupA);

    // sanity check (make sure we have rows selected)
    if (this.rowGroupB) this.curr_locations = this.getLocations(this.rowGroupB);

    if (this.curr_locations.length < 1) return;
  };
  // this should really be named haversine
  BatchGeoGroupDistance.prototype.euclideanDistance = function (
    lat1,
    lat2,
    lon1,
    lon2,
  ) {
    let distanceScale = window.batchGeoGoogleMapsManager.getDistanceScale();
    // The math module contains a function
    // named toRadians which converts from
    // degrees to radians.

    lon1 = (lon1 * Math.PI) / 180;
    lon2 = (lon2 * Math.PI) / 180;
    lat1 = (lat1 * Math.PI) / 180;
    lat2 = (lat2 * Math.PI) / 180;

    var earthRadius = {
      km: 6371,
      m: 6371 * 1000, // radius in meters times meters in a kilometer
      mi: 3959,
      ft: 3959 * 5280, // radius in miles times feet in a mile
    };

    // Haversine formula
    let dlon = lon2 - lon1;
    let dlat = lat2 - lat1;
    let a =
      Math.pow(Math.sin(dlat / 2), 2) +
      Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(dlon / 2), 2);

    let c = 2 * Math.asin(Math.sqrt(a));

    // Radius of earth in kilometers. Use 3956
    // for miles
    let r = earthRadius[distanceScale];

    // calculate the result
    return c * r;
  };

  BatchGeoGroupDistance.prototype.getLocations = function (rowSelections) {
    let markers = this.markers;
    return rowSelections.map(function (selectedRow) {
      var marker = markers[selectedRow];
      var location = marker.marker.addr;
      var position = new google.maps.LatLng({
        lat: marker.Lat,
        lng: marker.Lon,
      });
      return {
        value: location,
        desc: "from row number " + (selectedRow + 1),
        position: position,
      };
    });
  };

  BatchGeoGroupDistance.prototype.getLargestDistance = function (polylineData) {
    let largestDistance = -Infinity;
    let largestDistanceObject;
    // loop through the array
    for (let i = 0; i < polylineData.length; i++) {
      // check if the id of the current object is greater than the current largest id
      if (polylineData[i].distance > largestDistance) {
        largestDistance = polylineData[i].distance;
        largestDistanceObject = polylineData[i];
      }
    }
    return largestDistanceObject;
  };

  BatchGeoGroupDistance.prototype.getSmallestDistance = function (
    polylineData,
  ) {
    let smallestDistance = Infinity;
    let smallestDistanceObject;
    // loop through the array
    for (let i = 0; i < polylineData.length; i++) {
      // check if the id of the current object is greater than the current largest id
      if (polylineData[i].distance < smallestDistance) {
        smallestDistance = polylineData[i].distance;
        smallestDistanceObject = polylineData[i];
      }
    }
    return smallestDistanceObject;
  };

  BatchGeoGroupDistance.prototype.findClosestPairs = function (cities) {
    if (cities.length <= 1) {
      // Base case: if there is only one or zero cities, there are no pairs to compare
      return [];
    } else if (cities.length === 2) {
      // Base case: if there are only two cities, return them as the closest pair
      return [cities];
    } else {
      // Divide the list of cities into two halves
      const mid = Math.floor(cities.length / 2);
      const leftCities = cities.slice(0, mid);
      const rightCities = cities.slice(mid);

      // Recursively find the closest pairs in each half
      const leftPairs = this.findClosestPairs(leftCities);
      const rightPairs = this.findClosestPairs(rightCities);

      // Find the closest pair that crosses the midpoint
      let minDist = Infinity;
      let closestPairs;
      for (let i = 0; i < leftCities.length; i++) {
        for (let j = 0; j < rightCities.length; j++) {
          const dist = this.euclideanDistance(
            leftCities[i].latitude,
            rightCities[j].latitude,
            leftCities[i].longitude,
            rightCities[j].longitude,
          );
          if (dist < minDist) {
            minDist = dist;
            closestPairs = [[leftCities[i], rightCities[j]]];
          } else if (dist === minDist) {
            closestPairs.push([leftCities[i], rightCities[j]]);
          }
        }
      }

      // Merge the two sets of closest pairs
      const mergedPairs = [...leftPairs, ...rightPairs];
      if (minDist !== Infinity) {
        mergedPairs.push(...closestPairs);
      }

      // Sort the merged pairs by distance
      mergedPairs.sort((pair1, pair2) => {
        const dist1 = this.euclideanDistance(
          pair1[0].latitude,
          pair1[1].latitude,
          pair1[0].longitude,
          pair1[1].longitude,
        );
        const dist2 = this.euclideanDistance(
          pair2[0].latitude,
          pair2[1].latitude,
          pair2[0].longitude,
          pair2[1].longitude,
        );
        return dist1 - dist2;
      });
      // Return the n closest pairs
      return mergedPairs;
    }
  };

  //this should be changed to no longer return the matrix, but set up the matrix on the object (effectively combine create/set)
  BatchGeoGroupDistance.prototype.createEmptyMatrix = function () {
    let rows = this.prev_locations.length;
    let columns = this.curr_locations.length;
    var matrix = new Array(rows);

    for (let i = 0; i < rows; i++) {
      matrix[i] = new Array(columns);
    }

    return matrix;
  };

  BatchGeoGroupDistance.prototype.setMatrix = function (matrix) {
    if (!matrix) return [];

    this.distanceMatrix = [...matrix];
    this.backupDistances = [...matrix]; //need for reference to original
  };

  BatchGeoGroupDistance.prototype.fillDistanceMatrix = function () {
    return new Promise((resolve, _reject) => {
      for (let x = 0; x < this.prev_locations.length; x++) {
        for (let y = 0; y < this.curr_locations.length; y++) {
          var dist_obj = { point_a: "", point_b: "", distance: "" };

          dist_obj.point_a = x;
          dist_obj.point_b = y;
          dist_obj.distance = this.euclideanDistance(
            this.prev_locations[x].position.lat(),
            this.curr_locations[y].position.lat(),
            this.prev_locations[x].position.lng(),
            this.curr_locations[y].position.lng(),
          );

          let distance = dist_obj.distance;

          this.distanceMatrix[x][y] = distance;
          this.backupDistances[x][y] = distance;
        }
      }
      resolve();
    });
  };

  BatchGeoGroupDistance.prototype.findClosestDestination = function () {
    let path = [];
    for (let x = 0; x < this.prev_locations.length; x++) {
      let minValueInRow = Math.min.apply(null, this.distanceMatrix[x]);
      let destinationIndex = this.distanceMatrix[x].indexOf(minValueInRow);
      let pathPair = [x, destinationIndex];
      path.push(pathPair);
    }
    this.path = path;
  };

  BatchGeoGroupDistance.prototype.findClosestWithKdTree = function (version) {
    if (version == null || version == undefined) return -1;

    let cities = this.curr_locations.map((location) => {
      return {
        name: location.value,
        latitude: location.position.lat(),
        longitude: location.position.lng(),
      };
    });

    let saftey = 0;
    let path = [];

    if (version == 0) {
      for (let y = 0; y < cities.length; y++) {
        let distanceObjects = [];
        for (let x = 0; x < cities.length; x++) {
          if (cities[x] == null) continue;
          let startLocation = [cities[y].latitude, cities[y].longitude];
          const kdTree = new window.BatchGeoKdTree(cities, startLocation, y);

          let kdTreeResult = kdTree.run();
          if (kdTreeResult !== -1) distanceObjects.push(kdTreeResult);
        }

        distanceObjects.sort(function (a, b) {
          return a.distance - b.distance;
        });

        if (distanceObjects.length > 0) {
          path.push(distanceObjects[0]);
          distanceObjects = [];
        }
      }
    }

    if (version == 1) {
      let latch = Math.floor(cities.length / 2); // 11/2 = 5.5 -> 5 | 12/2 == 6

      while (saftey < latch) {
        //stay safe
        let distanceObjects = [];

        for (let x = 0; x < cities.length; x++) {
          if (cities[x] == null) continue;
          let startLocation = [cities[x].latitude, cities[x].longitude];
          const kdTree = new window.BatchGeoKdTree(cities, startLocation, x);

          let kdTreeResult = kdTree.run();
          if (kdTreeResult !== -1) distanceObjects.push(kdTreeResult);
        }

        distanceObjects.sort(function (a, b) {
          return a.distance - b.distance;
        });
        if (distanceObjects.length > 0) {
          let singleObject = distanceObjects[0]; // least distance
          cities[singleObject.startCityIndex] = null;
          cities[singleObject.endCityIndex] = null;
          path.push(distanceObjects[0]);
          distanceObjects = [];
        }
        saftey++;
      }
    }

    let newpath = [];
    if (path.length > 0) {
      if (version !== 2)
        newpath = path.map((pair) => [
          pair.startCityIndex,
          pair.endCityIndex,
          pair.distance,
        ]);
      else {
        for (let x = 0; x < path.length; x++) {
          let pathObject = path[x];
          newpath.push([
            pathObject[0].position,
            pathObject[1].position,
            this.euclideanDistance(
              pathObject[0].latitude,
              pathObject[1].latitude,
              pathObject[0].longitude,
              pathObject[1].longitude,
            ),
          ]);
        }
      }
    } else {
      return -1;
    }
    return newpath;
  };

  BatchGeoGroupDistance.prototype.createHeatMap = function () {
    //get the heat color pallet
    let thematicColor = window.batchGeoGoogleMapsMarker.options.heatColors;

    let markersData = window.batchGeoGoogleMapsMarker.options.markersData.mapRS; // just need a copy
    let datatable = window.batchGeoTableMap.data.dataRS;
    let mapRS = window.batchGeoTableMap.data.mapRS;
    //distances should exist here in the data table...
    let distanceColumnIndex =
      window.batchGeoTableMap.data.columnNames.length - 1;
    /*faux grouping for heat map distribution*/
    let arrayOfGroups = [];
    let groupsArray = [];
    //for all markers

    for (let x = 0; x < markersData.length; x++) {
      // var rowMarker = markersData[x];
      var gValue = datatable[x][distanceColumnIndex] || "";

      // foundGroup is a variable that will track if we found the group string in the arrayOfGroups variable which means we don't need to create a new group
      var foundGroup = false;
      // iterate through array of groups
      for (var c = 0; c < arrayOfGroups.length; c++) {
        // check group name equals the current markers group
        if (arrayOfGroups[c].name == gValue) {
          // the only weird thing we are doing here is concating group name with a string which causes JS to convert it to a string so we can use indexOf which is a simple string comparison function
          if (
            (arrayOfGroups[c].name + "").toLowerCase().indexOf("other") == -1
          ) {
            // we matched an existing group, so increment one
            arrayOfGroups[c].count++;
            // add index of map row to arrayOfGroups, now we have a pointer back to the index of the marker that we can use for filtering
            arrayOfGroups[c].all[arrayOfGroups[c].all.length] = x;
          }
          foundGroup = true; // set found to true
        }
      }

      // create new group because we didn't find the value in existing groups
      if (!foundGroup)
        arrayOfGroups[arrayOfGroups.length] = {
          name: gValue, // group name / string (this is what shows up in legend)
          count: 1, // number of markers in this group, start at 1
          all: [x], // array pointing to all markers in this group
        };
    }

    let gAc = arrayOfGroups;

    gAc.sort(function (a, b) {
      if (isNaN(BatchGeo.val(a.name))) {
        return 1;
      }
      if (isNaN(BatchGeo.val(b.name))) {
        return -1;
      }
      return BatchGeo.val(b.name) - BatchGeo.val(a.name);
    });

    gAc.sort(function (a, b) {
      return BatchGeo.val(a.name) - BatchGeo.val(b.name);
    }); // reverse sort order
    // let gap = gAc.length / (thematicColor.length) - 1

    var div = parseInt(gAc.length / (thematicColor.length - 1));
    let u = 0;

    if (div < 1) {
      div = 1;
    }

    for (let i = 0; i < gAc.length && u < thematicColor.length; i += div) {
      var m =
        gAc.length - 1 < i + div || u >= thematicColor.length - 1
          ? gAc.length - 1
          : i + div - 1;
      var groupName1 = gAc[i].name;
      var groupName2 = gAc[m].name;

      groupsArray[u] = { clr: /*markerColors[u]*/ thematicColor[u] }; // why use the markerColors if its a thematic build

      groupsArray[u].name =
        window.batchGeoGoogleMapsMarker.MarkerGroups.formatGroupName(
          groupName1,
        ) +
        (groupName1 == groupName2
          ? ""
          : " - " +
            window.batchGeoGoogleMapsMarker.MarkerGroups.formatGroupName(
              groupName2,
            ));

      groupsArray[u].all = {}; // init marker array
      for (var r = i; r <= m; r++) {
        // populate mapRS with correct colors
        for (let c = 0; c < gAc[r].all.length; c++) {
          let index = gAc[r].all[c];
          markersData[index].heatClr = groupsArray[u].clr;
          mapRS[index].heatClr = groupsArray[u].clr;
          groupsArray[u].all[gAc[r].all[c]] = 1; // add pointedatatr to marker index to group info
        }
      }
      u++;
    }

    /* end faux grouping */
  };

  BatchGeoGroupDistance.prototype.findLeastDistance = function () {
    let distances = [];

    let temp_previous_locations = [...this.prev_locations];
    let temp_curr_locations = [...this.curr_locations];
    let temp_previousRows = [...this.rowGroupA];
    let temp_currentRows = [...this.rowGroupB];

    while (
      temp_previous_locations.length > 0 &&
      temp_curr_locations.length > 0
    ) {
      let x = 0;
      while (x < temp_previous_locations.length) {
        let y = 0;
        while (y < temp_curr_locations.length) {
          var dist_obj = { point_a: "", point_b: "", distance: "" };

          dist_obj.point_a = x;
          dist_obj.point_b = y;

          dist_obj.distance = this.euclideanDistance(
            temp_previous_locations[x].position.lat(),
            temp_curr_locations[y].position.lat(),
            temp_previous_locations[x].position.lng(),
            temp_curr_locations[y].position.lng(),
          );

          distances.push(dist_obj);

          y++;
        }
        x++;
      }

      distances.sort((a, b) => a.distance - b.distance); // b - a for reverse sort

      var shortest_path = distances[0];
      var shortest_path_start = shortest_path.point_a; // an index in prev
      var shortest_path_end = shortest_path.point_b; // an index in curr

      var shortest_id = temp_previousRows[shortest_path_start];
      var shortest_end_id = temp_currentRows[shortest_path_end];

      this.selectedIds.push(shortest_id);
      this.selectedIds.push(shortest_end_id);

      var singlePair = {
        start: shortest_id,
        end: shortest_end_id,
        distance: shortest_path.distance,
      };
      this.selectedIdPairs.push(singlePair);

      var colorIndex = window.heatColors.indexOf(
        window.batchGeoTableMap.batchGeoTable.options.data.mapRS[
          singlePair.start
        ].heatClr,
      );

      var rowColor = "#" + window.heatHexArray[colorIndex];

      this.polylineData.push({
        start: temp_previous_locations[shortest_path.point_a].position,
        startId: singlePair.start,
        end: temp_curr_locations[shortest_path.point_b].position,
        endId: singlePair.end,
        distance: singlePair.distance,
        color: rowColor,
      });

      //remove the points
      temp_previous_locations.splice(shortest_path.point_a, 1);
      temp_curr_locations.splice(shortest_path.point_b, 1);
      temp_previousRows.splice(shortest_path.point_a, 1);
      temp_currentRows.splice(shortest_path.point_b, 1);

      distances = [];
    }
    if (this.polylineData.length == 0) return -1;
  };

  BatchGeoGroupDistance.prototype.setPath = function (path) {
    if (!path) return;
    //set the path
    this.path = path;
  };

  BatchGeoGroupDistance.prototype.createPolylineData = function () {
    for (let x = 0; x < this.prev_locations.length; x++) {
      var shortest_path = this.distanceMatrix[this.path[x][0]][this.path[x][1]];
      var shortest_path_start = this.path[x][0]; // an index in prev
      var shortest_path_end = this.path[x][1]; // an index in curr

      var shortest_id = this.rowGroupA[shortest_path_start];
      var shortest_end_id = this.rowGroupB[shortest_path_end];
      if (shortest_id == undefined || shortest_end_id == undefined) continue;
      this.selectedIds.push(shortest_id);
      this.selectedIds.push(shortest_end_id);

      var singlePair = {
        start: shortest_id,
        end: shortest_end_id,
        distance: shortest_path,
      };

      this.selectedIdPairs.push(singlePair);
      var colorIndex = window.heatColors.indexOf(
        window.batchGeoTableMap.batchGeoTable.options.data.mapRS[
          singlePair.start
        ].heatClr,
      );
      //this allows us to set the polyline color relative to the other
      var rowColor = "#" + window.heatHexArray[colorIndex];

      this.polylineData.push({
        start: this.prev_locations[shortest_path_start].position,
        startId: singlePair.start,
        end: this.curr_locations[shortest_path_end].position,
        endId: singlePair.end,
        distance: singlePair.distance,
        color: rowColor,
      });
    }
  };

  BatchGeoGroupDistance.prototype.createSingleGroupPolylinesData = function (
    path,
  ) {
    //varies from the original createPolylines, by way of source data
    //uses passed in path, and only references curr_locations due to single group nature

    for (let x = 0; x < path.length; x++) {
      var shortest_path = path[x][2];
      var shortest_path_start = path[x][0]; // an index in prev(curr)
      var shortest_path_end = path[x][1]; // an index in curr

      var shortest_id = this.rowGroupB[shortest_path_start];
      var shortest_end_id = this.rowGroupB[shortest_path_end];
      if (shortest_id == undefined || shortest_end_id == undefined) continue;
      this.selectedIds.push(shortest_id);
      this.selectedIds.push(shortest_end_id);

      var singlePair = {
        start: shortest_id,
        end: shortest_end_id,
        distance: shortest_path,
      };
      this.selectedIdPairs.push(singlePair);
      var colorIndex = window.colorPallet.indexOf(
        window.batchGeoTableMap.batchGeoTable.options.data.mapRS[
          singlePair.start
        ].clr,
      );

      var rowColor = "#" + window.hex[colorIndex];
      this.polylineData.push({
        start: this.curr_locations[shortest_path_start].position,
        startId: singlePair.start,
        end: this.curr_locations[shortest_path_end].position,
        endId: singlePair.end,
        distance: singlePair.distance,
        color: rowColor,
      });
    }
  };

  BatchGeoGroupDistance.prototype.setupRowData = function () {
    for (let q = 0; q < this.selectedIdPairs.length; q++) {
      let pair = this.selectedIdPairs[q];

      var realRowData =
        window.batchGeoGoogleMapsMarker.options.markersData.dataRS[pair.start];
      var realDestinationData =
        window.batchGeoGoogleMapsMarker.options.markersData.dataRS[pair.end];

      if (this.columnCount == 0) {
        this.columnCount =
          window.batchGeoTableMap.batchGeoTable.data.columns.length;
      }

      //only need the distance from the pair, and the first location stored in data

      if (realRowData) {
        // this if block handles the distance column for a given row
        if (realRowData.length < this.columnCount + 1) {
          realRowData.push(String(Math.round(pair.distance * 10) / 10));
        } else {
          realRowData[this.columnCount] = String(
            Math.round(pair.distance * 10) / 10,
          );
        }

        //destination column for a given row
        if (realRowData.length < this.columnCount + 2) {
          realRowData.push(realDestinationData);
        } else {
          realRowData[this.columnCount + 1] = realDestinationData;
        }
        let dataObject = {};
        let key = pair.start;

        dataObject[key] = realRowData;

        this.rowData.push(dataObject);
      }
    }
    // compose rowDataByStartId hash
    if (this.rowData.length) {
      this.rowData.forEach((item) => {
        const key = Object.keys(item)[0];
        this.rowDataByStartId[key] = item[key];
      });
    }
  };

  BatchGeoGroupDistance.prototype.normalizeLength = function (
    length,
    minLength,
    maxLength,
  ) {
    // Determine the range of lengths
    const range = maxLength - minLength;

    // Normalize the given length
    const ratio = (length - minLength) / range;

    let r, g, b;
    switch (true) {
      case ratio <= 0.1:
        r = 0;
        g = 255;
        b = 0;
        break;
      case ratio > 0.1 && ratio <= 0.2:
        r = 127;
        g = 255;
        b = 0;
        break;
      case ratio > 0.2 && ratio <= 0.3:
        r = 191;
        g = 255;
        b = 0;
        break;
      case ratio > 0.3 && ratio <= 0.4:
        r = 223;
        g = 255;
        b = 0;
        break;
      case ratio > 0.4 && ratio <= 0.5:
        r = 255;
        g = 255;
        b = 0;
        break;
      case ratio > 0.5 && ratio <= 0.6:
        r = 255;
        g = 223;
        b = 0;
        break;
      case ratio > 0.6 && ratio <= 0.7:
        r = 255;
        g = 191;
        b = 0;
        break;
      case ratio > 0.7 && ratio <= 0.8:
        r = 255;
        g = 127;
        b = 0;
        break;
      case ratio > 0.8 && ratio <= 0.9:
        r = 255;
        g = 63;
        b = 0;
        break;
      default:
        r = 255;
        g = 0;
        b = 0;
    }

    // Return the color as a string in the format "rgb(r, g, b)"
    return `rgb(${r}, ${g}, ${b})`;
  };

  BatchGeoGroupDistance.prototype.buildPolylines = function () {
    //create polylines
    //window.batchGeoGoogleMapsMarker.MarkerLegend.updatePolylineColors();
    //need to update polylines here...

    //need start values index...
    let startIds = this.polylineData.map((polyline) => polyline.startId);
    let markers = window.batchGeoGoogleMapsMarker.options.markersData.mapRS;

    for (let q = 0; q < this.polylineData.length; q++) {
      let colorIndex = window.heatColors.indexOf(markers[startIds[q]].heatClr);
      var rowColor = "#" + window.heatHexArray[colorIndex];

      this.polylineData[q].color = rowColor;
    }

    for (
      let polylineDataPoints = 0;
      polylineDataPoints < this.polylineData.length;
      polylineDataPoints++
    ) {
      // let heatColor = markers[startIds[polylineDataPoints]].heatClr
      var map = window.batchGeoGoogleMapsManager.getMap();
      let polyline = new google.maps.Polyline({
        map: map,
        path: [
          this.polylineData[polylineDataPoints].start,
          this.polylineData[polylineDataPoints].end,
        ],
        strokeColor: rowColor || "#4285F4",
        strokeOpacity: 0.8,
      });

      //store polyline object
      window.batchGeoTableMap.addToListForDispatch({
        polyline: polyline,
        startId: this.polylineData[polylineDataPoints].startId,
      });
    }
  };

  BatchGeoGroupDistance.prototype.getMatrix = function () {
    return this.distanceMatrix;
  };

  BatchGeoGroupDistance.prototype.addNewColumnsToDataview = function () {
    let metric =
      window.batchGeoTableMap.optimalDistanceColumnGenerator.generateColumn(
        this.rowData,
      );
    window.batchGeoTableMap.destinationColumnGenerator.generateColumn(
      this.rowData,
    );
    window.batchGeoGoogleMapsMarker.MarkerLegend.updateColumnList();
    window.batchGeoGoogleMapsMarker.MarkerLegend.filterColumns(true);
    window.batchGeoGoogleMapsMarker.MarkerLegend.updateColumnList();
    window.batchGeoGoogleMapsMarker.MarkerLegend.setMetricValue(metric);

    //remove no-menu class from dropdown to allow distance column on single column legends

    // Find the first element with a specific class
    var columnWrapDiv = $(".no-menu:first");
    // Remove the class from the element
    if (columnWrapDiv) columnWrapDiv.removeClass("no-menu");
  };

  BatchGeoGroupDistance.prototype.removeColumnsFromDataview = function () {
    let distanceIndex =
      window.batchGeoTableMap.batchGeoTable.data.columns.indexOf(
        "Distance Between Points",
      );
    let destinationIndex =
      window.batchGeoTableMap.batchGeoTable.data.columns.indexOf("Destination");
    if (distanceIndex) {
      window.batchGeoTableMap.batchGeoTable.data.columns.splice(
        distanceIndex,
        1,
      );
      let columnIndex = window.per.columnNames.length;
      let index = window.per.columnNames.indexOf(columnIndex);
      window.per.legend_columns.splice(index, 1);
    }
    if (destinationIndex) {
      window.batchGeoTableMap.batchGeoTable.data.columns.splice(
        destinationIndex,
        1,
      );
    }

    window.batchGeoGoogleMapsMarker.MarkerLegend.updateColumnList();

    window.batchGeoGoogleMapsMarker.MarkerLegend.filterColumns(true);

    window.batchGeoGoogleMapsMarker.MarkerLegend.updateColumnList();
  };

  BatchGeoGroupDistance.prototype.addDataColumnsToRows = function () {
    var limit = window.batchGeoTableMap.batchGeoTable.data.columns.length;
    // var trueLimit = window.batchGeoGoogleMapsMarker.options.markersData
    window.batchGeoTableMap.batchGeoTable.data.rows.forEach(function (row) {
      if (row && row.data.length < limit) {
        row.data.push(" ");
        row.data.push(" ");
      }
    });
    window.batchGeoGoogleMapsMarker.options.markersData.dataRS.forEach(
      function (row) {
        if (row && row.length < limit) {
          row.push(" ");
          row.push(" ");
        }
      },
    );
  };

  BatchGeoGroupDistance.prototype.trimRows = function () {
    var rowSelect = window.batchGeoTableMap.batchGeoTable.RowSelect;

    let currentRows =
      BatchGeoStore.getState().BatchGeoOptimalRouteToolbar.currentRows;
    let previousRows =
      BatchGeoStore.getState().BatchGeoOptimalRouteToolbar.previousRows;

    let trimmedRowsPrevious;
    let trimmedRowsCurrent;

    if (previousRows.length > 25) {
      trimmedRowsPrevious = previousRows.slice(0, 25);
      rowSelect.select(trimmedRowsPrevious, { fromMarkerClick: true });
    }

    if (currentRows.length > 25) {
      trimmedRowsCurrent = currentRows.slice(0, 25);
      rowSelect.select(trimmedRowsCurrent, { fromMarkerClick: true });
    }
  };

  BatchGeoGroupDistance.prototype.fixRows = function () {
    let rowSelect = window.batchGeoTableMap.batchGeoTable.RowSelect;
    let currentRows =
      BatchGeoStore.getState().BatchGeoOptimalRouteToolbar.currentRows;
    let previousRows =
      BatchGeoStore.getState().BatchGeoOptimalRouteToolbar.previousRows;

    let trimmedRowsPrevious;
    let trimmedRowsCurrent;

    if (previousRows.length > 25 || currentRows.length > 25) {
      let message = "Calculations are limited to 25 markers per selection.";
      if (previousRows.length && currentRows.length) {
        message +=
          " 50 distance calculations in the data table. 25 polylines for visual representation on map.";
      }
      BatchGeo.blockAlert(message, () => {});
    }

    if (previousRows.length > 25) {
      trimmedRowsPrevious = previousRows.slice(0, 25);
    } else {
      trimmedRowsPrevious = previousRows;
    }
    rowSelect.select(trimmedRowsPrevious, { fromMarkerClick: true });

    if (currentRows.length > 25) {
      trimmedRowsCurrent = currentRows.slice(0, 25);
    } else {
      trimmedRowsCurrent = currentRows;
    }
    rowSelect.select(trimmedRowsCurrent, { fromMarkerClick: true });
  };

  BatchGeoGroupDistance.prototype.selectRows = function () {
    var rows = window.batchGeoTableMap.batchGeoTable.data.rows;

    var sRows = [];

    var rowSelect = window.batchGeoTableMap.batchGeoTable.RowSelect;

    // // Update the sort and once that is completely finished and the DOM is
    // // done being manipulated update the selections
    window.batchGeoTableMap.batchGeoTable.render();

    rowSelect.select(this.selectedIds, { fromMarkerClick: false });

    var selectedRows = rowSelect.getSelectedRows();

    // //extract the Ids into an array
    var selectedRowIds = selectedRows.map((row) => row.id);
    // todo: [ROW ORDER] check to make sure this works
    rows.forEach((row) => {
      if (
        row.data[this.columnCount] == "" &&
        selectedRowIds.indexOf(row.id) == -1
      ) {
        // for items without a distance => to the end
        sRows.push(row);
      } else {
        // for items with a distance => to the top
        sRows.unshift(row);
      }
    });

    // //update the row display
    window.batchGeoTableMap.batchGeoTable.updateRowDisplay(sRows, () => {});
  };

  BatchGeoGroupDistance.prototype.updateState = function () {
    BatchGeoStore.dispatch([
      {
        type: "OPTIMAL_ROUTE_POLYLINE_DATA",
        polylineData: this.polylineData,
      },
      {
        type: "OPTIMAL_ROUTE_GROUP_DISTANCE_ENGAGED",
        isEngaged: false,
      },
      {
        type: "OPTIMAL_ROUTE_TOOLBAR_VISIBILITY",
        isVisible: true,
      },
    ]);
  };

  BatchGeoGroupDistance.prototype.setupListeners = function () {
    const self = this;
    BatchGeoStore.addListener("RowSelect", "selection", function (newState) {
      // have title column to toggle destination value
      // have destination column on view
      // have batchGeoGroupDistance data used to toggle destination value
      if (
        window.per.title_col > -1 &&
        window.batchGeoTableMap.batchGeoTable.data.columns.indexOf(
          "Destination",
        ) > -1 &&
        window.batchGeoGroupDistance
      ) {
        // column index
        let destinationColumnIndex =
          window.batchGeoTableMap.batchGeoTable.data.columns.indexOf(
            "Destination",
          );

        // {1: true, 2: true, 3: true}
        const newHash = newState.selection.reduce((acc, curr) => {
          acc[curr] = true;
          return acc;
        }, {});

        // accumulate update data
        const updates = [];

        // convert new selections into update data
        const newSelections = newState.selection;
        updates.push(
          ...self.composeDestinationData(newSelections, "title_col"),
        );

        // convert previous selections into update data
        const prevSelections = newState.previousSelection.filter(
          (row) => !newHash[row],
        );
        updates.push(
          ...self.composeDestinationData(prevSelections, "address_col"),
        );

        // update dom
        updates.forEach((item) => {
          $(
            `tr[data-id="${item.r}"] td:nth-child(${destinationColumnIndex + 1})`,
          ).text(item.destination);
        });
      }
    });
  };

  BatchGeoGroupDistance.prototype.composeDestinationData = function (
    rows,
    perKey,
  ) {
    const updates = [];
    rows.forEach((item) => {
      if (window.batchGeoGroupDistance && this.rowDataByStartId[item]) {
        // Row data is an array of the starting location data with the last item
        // in array being an array of the destination location data.
        const rowData = this.rowDataByStartId[item];
        updates.push({
          r: item,
          destination: rowData[rowData.length - 1][window.per[perKey]],
        });
      }
    });
    return updates;
  };

  BatchGeoGroupDistance.prototype.update = function () {
    window.batchGeoTableMap.batchGeoTable.render();
  };

  BatchGeoGroupDistance.prototype.singleGroupDistance = function (version) {
    let fauxPath = this.findClosestWithKdTree(version);
    if (fauxPath == -1) return -1;
    this.createSingleGroupPolylinesData(fauxPath);
    this.setupRowData();
    this.addNewColumnsToDataview();
    this.selectRows();
    this.updateState();
  };

  BatchGeoGroupDistance.prototype.leastDistance = function () {
    let result = this.findLeastDistance();
    if (result == -1) return -1;
    this.setupRowData();
    this.addNewColumnsToDataview();
    this.selectRows();
    this.updateState();
  };

  BatchGeoGroupDistance.prototype.closestNeighbor = function () {
    this.findClosestDestination();
    this.createPolylineData();
    this.setupRowData();
    this.addNewColumnsToDataview();
    this.selectRows();
    this.updateState();
  };

  BatchGeoGroupDistance.prototype.closestUniqueNeighbor = function () {
    this.createPolylineData();
    this.setupRowData();
    this.addNewColumnsToDataview();
    this.selectRows();
    this.updateState();
  };

  window.BatchGeoGroupDistance = BatchGeoGroupDistance;
})(window);
